import type { Types } from '@fiverr-private/theme';
import type { HighlightType } from './types';

export const TYPES = {
    NEUTRAL: 'neutral',
    INFO: 'info',
    WARNING: 'warning',
    SUCCESS: 'success',
    ERROR: 'error',
    ai: 'ai',
} as const;

export const COLORS_BY_TYPE: {
    [key in HighlightType]: {
        color: Types.BoxType['color'];
        backgroundColor: Types.BoxType['backgroundColor'];
    };
} = {
    neutral: {
        color: 'grey_1200',
        backgroundColor: 'grey_200',
    },
    info: {
        color: 'blue_1100',
        backgroundColor: 'blue_100',
    },
    warning: {
        color: 'yellow_1200',
        backgroundColor: 'yellow_100',
    },
    success: {
        color: 'green_1100',
        backgroundColor: 'green_100',
    },
    error: {
        color: 'red_1100',
        backgroundColor: 'red_100',
    },
    ai: {
        color: 'purple_1100',
        backgroundColor: 'purple_100',
    },
};
